import script from "./CameraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraModal.vue?vue&type=script&setup=true&lang=js"

import "./CameraModal.vue?vue&type=style&index=0&id=407e5136&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407e5136"]])

export default __exports__